import { useFormikContext } from 'formik'
import { JourneyFormType } from '../types'

export const useJourneyFormContext = () => {
  const context = useFormikContext<JourneyFormType>()
  return context
}
